import { render, staticRenderFns } from "./StatisticsTabItem.vue?vue&type=template&id=d20fa52c&scoped=true"
import script from "./StatisticsTabItem.vue?vue&type=script&lang=js"
export * from "./StatisticsTabItem.vue?vue&type=script&lang=js"
import style0 from "./StatisticsTabItem.vue?vue&type=style&index=0&id=d20fa52c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d20fa52c",
  null
  
)

export default component.exports